import React from 'react'
import root from '../shared/utils'
import { Modal } from 'react-bootstrap'
import { getTaskTypeIconParser } from '../shared/enums/task-type-icon-parser'
import { getOrdinalDate } from '../shared/enums/date-parser'
import { acceptTask } from '../api'

export default React.createClass({
  getInitialState: function () {
    return {
      taskTitle: '',
      date: '',
      orderNum: '',
      price: '',
      beforeArray: [],
      afterArray: [],
      buttonsGroup: '',
      messageId: '',
    }
  },
  componentWillReceiveProps: function (nextProps) {
    let beforePics = []
    let afterPics = []
    let buttons = ''
    if (!nextProps.modalCard) {
      return
    }
    if (nextProps.modalCard.mobileJob && nextProps.modalCard.mobileJob.jobPhotos) {
      for (let i = 0; i < nextProps.modalCard.mobileJob.jobPhotos.length; i++) {
        if (nextProps.modalCard.mobileJob.jobPhotos[i].photoType === 'JOB_BEFORE') {
          let image = nextProps.modalCard.mobileJob.jobPhotos[i].fullSizeUrl
          let title = nextProps.modalCard.mobileJob.jobPhotos[i].orientationTitle
          let type = nextProps.modalCard.mobileJob.jobPhotos[i].photoTypeText
          beforePics.push(<div key={i}>
            <div className='pull-down-xs-4 hidden-sm hidden-xs'>
              <p style={{ float: 'left' }}>{title} - {type}</p>
              <img src={image} alt="" style={{ height: '255px', width: '345px' }} />
            </div>
            <div key={(i + nextProps.modalCard.mobileJob.jobPhotos.length)} className='text-center pull-down-xs-4 visible-sm visible-xs'>
              <p>{title} - {type}</p>
              <img src={image} alt="" style={{ height: '153px', width: '222px' }} />
            </div>
          </div>)
        }
        else {
          let image = nextProps.modalCard.mobileJob.jobPhotos[i].fullSizeUrl
          let title = nextProps.modalCard.mobileJob.jobPhotos[i].orientationTitle
          let type = nextProps.modalCard.mobileJob.jobPhotos[i].photoTypeText
          afterPics.push(<div key={i}>
            <div className='pull-down-xs-4 hidden-sm hidden-xs'>
              <p style={{ float: 'left' }}>{title} - {type}</p>
              <img src={image} alt="" style={{ height: '255px', width: '345px' }} />
            </div>
            <div key={(i + nextProps.modalCard.mobileJob.jobPhotos.length)} className='text-center pull-down-xs-4 visible-sm visible-xs'>
              <p>{title} - {type}</p>
              <img src={image} alt="" style={{ height: '153px', width: '222px' }} />
            </div>
          </div>)
        }
      }
      if (nextProps.modalCard.subActivityType !== 'JOB_CLOSED') {
          buttons = <div className='text-center'>
              <button className='btn btn-success' style={{marginRight: 10}} onClick={this.sendAcceptToServer}>Approve</button>
              <button className='btn btn-info' style={{marginLeft: 10}} onClick={this.sendDeclineToServer}>Decline</button>
          </div>
      }
      let jobDate
      if (nextProps.modalCard.millisDate) {
        jobDate = getOrdinalDate(nextProps.modalCard.millisDate)
      }
      else {
        jobDate = getOrdinalDate((nextProps.modalCard.eventDate * 24 * 60 * 60 * 1000 + 86400000))
      }
      let payment = nextProps.modalCard.mobileJob.cost.toString()
      if (payment.length === 4) {
        payment += '0'
      }
      this.setState({ taskTitle: getTaskTypeIconParser(nextProps.modalCard.taskType).prettify, date: jobDate, orderNum: nextProps.modalCard.mobileJob.taskId, price: payment, beforeArray: beforePics, afterArray: afterPics, messageId: nextProps.modalCard.messageId, buttonsGroup: buttons })
    }
  },
  sendAcceptToServer: function () {
    acceptTask(this.props.modalCard.mobileJob.jobId).then((response) => {
      if (response !== 'error') {
        this.props.openAcceptTaskModal(this.props.modalCard.authenticationCode, this.props.modalCard.mobileJob.comment, this.props.modalCard)
        this.props.hide()
      }
      else {
        this.props.openNotificationModal('job-finished-modal', "Processing Error", "There was an error processing your approval. Please try again later.")
        this.props.hide()
      }
    })
  },
  sendDeclineToServer: function () {
    this.props.openDeclineTaskModal()
    this.props.hide()
  },
  render: function () {
    let mediaRoot = root + '/common/latest/images/consumer/status-icons'
    let checkmark = mediaRoot + '/FINISHED-flat.png'

    return (
      <div>
        <Modal show={this.props.show} onHide={this.props.hide} dialogClassName='my-modal-size'>
          <Modal.Header closeButton>
            <div className='text-center pull-down-xs-3'>
              <img src={checkmark} style={{ height: '40px', width: '50px' }} alt='checkmark'></img>
            </div>
            <h2 className='text-center'>{this.state.taskTitle} Finished</h2>
            <p className='text-center pull-down-xs-2' style={{ padding: '0 10px 0 10px', fontSize: '24px' }}>Finished on: <b>{this.state.date}</b></p>
          </Modal.Header>
          <Modal.Footer>
            <div className='row'>
              <div className='col-sm-6 col-xs-12 text-center'>
                <h6>Order #{this.state.orderNum}</h6>
              </div>
              <div className='col-sm-6 col-xs-12 text-center'>
                <h6 className='brand-primary-color'>Price: ${this.state.price}</h6>
              </div>
            </div>
            <div className='text-center pull-down-xs-3'>
              <div style={{ width: '90%', margin: 'auto' }} dangerouslySetInnerHTML={{ __html: this.state.modalCard ? this.state.modalCard.content : '' }} />
            </div>
            <div className='row pull-down-xs-2'>
              {this.state.buttonsGroup}
            </div>
            <div className='row' style={{ width: '90%', margin: 'auto', paddingBottom: '30px' }}>
              <div className='col-sm-6 col-xs-12'>
                {this.state.beforeArray}
              </div>
              <div className='col-sm-6 col-xs-12'>
                {this.state.afterArray}
              </div>
            </div>
          </Modal.Footer>
        </Modal>
      </div>
    )
  }
})



// WEBPACK FOOTER //
// ./src/components/modals/job-finished-modal.jsx